import {
  useTroubleshootReferenceLocations,
} from "../../utils/ticket/TicketTroubleshootRefrences";

export default function TroubleshootLocationSelect({
  value,
  onChange,
  manualValue,
  onManualChange,
  required,
  disabled,
}) {
  const { data: locations, loading } = useTroubleshootReferenceLocations();
  const showManual = value && locations.find((loc) => loc.id === value)?.manual_input;

  return (
    <div className="form-group">
      <label>
        Lokasi Masalah {required && <span className="text-danger">*</span>}
      </label>
      <select
        className="form-control"
        value={value}
        onChange={onChange}
        required={required}
        disabled={disabled}
      >
        <option value="">-- Pilih Lokasi --</option>
        {loading ? (
          <option>Loading...</option>
        ) : (
          locations.map((loc) => (
            <option key={loc.id} value={loc.id}>
              {loc.name}
            </option>
          ))
        )}
      </select>
      {showManual && (
        <input
          type="text"
          className="form-control mt-2"
          value={manualValue}
          onChange={onManualChange}
          placeholder="Masukkan lokasi manual..."
          required
        />
      )}
    </div>
  );
}
